import * as types from "../constants/ActionTypes";

const messagesheader = (state = [], action) => {
  switch (action.type) {
    case types.ADD_MESSAGEHEADER:
      let text = {};
      try {
        text = {
          [action.contactid]: [{ header: action.header }],
        };
        // var obj = JSON.parse(text);
      } catch (e) {
        text = {
          [action.contactid]: [{ header: action.header }],
        };

        // var obj = JSON.parse(text);
      }

      var newState = { ...state };

      if (Object.keys(text)[0] in newState) {
        let key = Object.keys(text)[0];
        newState[key] = [text[key][0]];
        // newState[key].push(text[key][0]);
        return newState;
      } else {
        let key = Object.keys(text)[0];
        newState[key] = [text[key][0]];
        return newState;
      }

    case types.CLEAR_MESSAGEHEADER:
      delete state[action.contactid];
      return state;
    default:
      return state;
  }
};

export default messagesheader;
